/** Base URL for docs/examples (matches apiService + env). */
export function getApiDisplayBase() {
  const raw = process.env.REACT_APP_API_URL;
  if (raw != null && String(raw).trim() !== "") {
    return String(raw).trim().replace(/\/+$/, "");
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin.replace(/\/+$/, "")}/api`;
  }
  return "/api";
}
